export { default as dataSharingQueries } from './basic'